import { LifecycleStatus, TemplatePublicationStatus } from '@/gql/graphql';
import { cn } from '@/lib/utils';
import { VariantProps, cva } from 'class-variance-authority';
import React from 'react';

const pillVariants = cva(
  cn('typo-primary-300 bg-system-success-bg text-system-success py-[0.5] px-3 rounded-[20px] inline-flex'),
  {
    variants: {
      variant: {
        default: '',
        neutral: 'bg-light-gray text-secondary-text',
        db: 'bg-pill-db-bg text-pill-db',
        bb: 'bg-pill-bb-bg text-pill-bb',
        ms: 'bg-pill-ms-bg text-pill-ms',
        do: 'bg-pill-do-bg text-pill-do',
      },
      productStatus: {
        [LifecycleStatus.New]:
          'h-[20px] flex-inline items-center rounded-[2px] px-1 justify-center typo-label bg-product-status-new text-product-status-new-text',
        [LifecycleStatus.InProgress]:
          'h-[20px] flex-inline items-center rounded-[2px] px-1 justify-center typo-label bg-product-status-in-progress text-product-status-in-progress-text',
        [LifecycleStatus.Retired]:
          'h-[20px] flex-inline items-center rounded-[2px] px-1 justify-center typo-label bg-product-status-retired text-product-status-retired-text',
        [LifecycleStatus.Transmitted]:
          'h-[20px] flex-inline items-center rounded-[2px] px-1 justify-center typo-label bg-product-status-transmitted text-product-status-transmitted-text',
      },
      templateStatus: {
        [TemplatePublicationStatus.Private]:
          'h-[20px] rounded-[2px] px-1 flex-inline items-center justify-center typo-label bg-template-status-private text-template-status-private-text',
        [TemplatePublicationStatus.Published]:
          'h-[20px] rounded-[2px] px-1 flex-inline items-center justify-center typo-label bg-template-status-published text-template-status-published-text',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

const convertText = (text?: string) => {
  if (!text) return '';
  return text.replace(/_/g, ' ');
};

type PillVariantProps = VariantProps<typeof pillVariants>;

interface PillProps extends React.HTMLAttributes<HTMLDivElement>, PillVariantProps {
  text?: string;
}

export const Pill = React.forwardRef<HTMLDivElement, PillProps>(
  ({ className, text, variant, productStatus, templateStatus, ...props }, ref) => {
    return (
      <div className={cn(pillVariants({ variant, productStatus, templateStatus }), className)} ref={ref} {...props}>
        {convertText(text)}
      </div>
    );
  },
);

Pill.displayName = 'Pill';
